import Vue from 'vue'
// import * as firebaseUtil from '../../firebase/firebaseUtil'

export default {
    state: {
        enableStempel: true,
        stempelType: 1,
        stempelRabattAmount: 15,
        // wantsToRedeemStempel: false,

        stempelkarte: {
            fuid: '',
            punktestand: 0,
            // gutscheinCodes: [
            // {
            //     code: 'AGKRW',
            //     betrag: 30,
            // }
            // ]
        },
    },
    actions: {},
    mutations: {

        stempelkarte(state, payload) {
            // let karte = {
            //     punktestand: payload.punktestand,
            //     // gutscheinCodes: state.gutscheinCodes
            // };
            // if (payload.gutscheinCodes) {
            //     karte.gutscheinCodes = payload.gutscheinCodes;
            // }
            Object.assign(state.stempelkarte, payload);
        },


    },
    getters: {
        enableStempel: (state) => {
            return state.enableStempel;
        },

        stempelType: (state) => {
            return state.stempelType;
        },

        stempelRabattAmount: (state) => {
            return state.stempelRabattAmount;
        },


        stempelkarte: (state) => {
            return state.stempelkarte;
        },

        // wantsToRedeemStempel: (state) => {
        //     return state.wantsToRedeemStempel;
        // },

    }
};
